/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FileRefInputSchema } from './FileRefInputSchema';
import {
    FileRefInputSchemaFromJSON,
    FileRefInputSchemaFromJSONTyped,
    FileRefInputSchemaToJSON,
} from './FileRefInputSchema';
import type { FilestoreAttachmentRequest } from './FilestoreAttachmentRequest';
import {
    FilestoreAttachmentRequestFromJSON,
    FilestoreAttachmentRequestFromJSONTyped,
    FilestoreAttachmentRequestToJSON,
} from './FilestoreAttachmentRequest';
import type { SidecarSchema } from './SidecarSchema';
import {
    SidecarSchemaFromJSON,
    SidecarSchemaFromJSONTyped,
    SidecarSchemaToJSON,
} from './SidecarSchema';
import type { SupersetRuntimeOptionsAPISchema } from './SupersetRuntimeOptionsAPISchema';
import {
    SupersetRuntimeOptionsAPISchemaFromJSON,
    SupersetRuntimeOptionsAPISchemaFromJSONTyped,
    SupersetRuntimeOptionsAPISchemaToJSON,
} from './SupersetRuntimeOptionsAPISchema';

/**
 * 
 * @export
 * @interface CreateClusterSchema
 */
export interface CreateClusterSchema {
    /**
     * 
     * @type {string}
     * @memberof CreateClusterSchema
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClusterSchema
     */
    softwareEnvironment?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CreateClusterSchema
     */
    environ?: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof CreateClusterSchema
     */
    privateToCreator?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateClusterSchema
     */
    clusterTimeoutSeconds?: number;
    /**
     * 
     * @type {SupersetRuntimeOptionsAPISchema}
     * @memberof CreateClusterSchema
     */
    options?: SupersetRuntimeOptionsAPISchema;
    /**
     * 
     * @type {number}
     * @memberof CreateClusterSchema
     */
    workers: number;
    /**
     * 
     * @type {string}
     * @memberof CreateClusterSchema
     */
    workerClass?: string;
    /**
     * 
     * @type {object}
     * @memberof CreateClusterSchema
     */
    workerOptions?: object;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateClusterSchema
     */
    workerInstanceTypes: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CreateClusterSchema
     */
    workerDiskSize?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateClusterSchema
     */
    workerDiskThroughput?: number;
    /**
     * 
     * @type {object}
     * @memberof CreateClusterSchema
     */
    workerDiskConfig?: object;
    /**
     * 
     * @type {string}
     * @memberof CreateClusterSchema
     */
    schedulerClass?: string;
    /**
     * 
     * @type {object}
     * @memberof CreateClusterSchema
     */
    schedulerOptions?: object;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateClusterSchema
     */
    schedulerInstanceTypes: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CreateClusterSchema
     */
    schedulerDiskSize?: number;
    /**
     * 
     * @type {object}
     * @memberof CreateClusterSchema
     */
    schedulerDiskConfig?: object;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CreateClusterSchema
     */
    tags?: { [key: string]: string; };
    /**
     * 
     * @type {object}
     * @memberof CreateClusterSchema
     */
    daskConfig?: object;
    /**
     * 
     * @type {boolean}
     * @memberof CreateClusterSchema
     */
    extraWorkerOnScheduler?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateClusterSchema
     */
    nWorkerSpecsPerHost?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateClusterSchema
     */
    envId?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateClusterSchema
     */
    envName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClusterSchema
     */
    coiledCloudEnvImage?: string;
    /**
     * 
     * @type {object}
     * @memberof CreateClusterSchema
     */
    autoSpec?: object;
    /**
     * 
     * @type {boolean}
     * @memberof CreateClusterSchema
     */
    useAwsCredsEndpoint?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateClusterSchema
     */
    customSubdomain?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateClusterSchema
     */
    batchJobIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof CreateClusterSchema
     */
    extraUserContainer?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateClusterSchema
     */
    extraUserContainerIgnoreEntrypoint?: boolean;
    /**
     * 
     * @type {Array<SidecarSchema>}
     * @memberof CreateClusterSchema
     */
    schedulerSidecars?: Array<SidecarSchema>;
    /**
     * 
     * @type {Array<SidecarSchema>}
     * @memberof CreateClusterSchema
     */
    workerSidecars?: Array<SidecarSchema>;
    /**
     * 
     * @type {string}
     * @memberof CreateClusterSchema
     */
    hostSetupScript?: string;
    /**
     * 
     * @type {Array<FileRefInputSchema>}
     * @memberof CreateClusterSchema
     */
    userFileRefs?: Array<FileRefInputSchema>;
    /**
     * 
     * @type {Array<FilestoreAttachmentRequest>}
     * @memberof CreateClusterSchema
     */
    filestoresToAttach?: Array<FilestoreAttachmentRequest>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateClusterSchema
     */
    pauseOnExit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateClusterSchema
     */
    skipSsdMount?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CreateClusterSchema
     */
    localVersions?: { [key: string]: string; };
}

/**
 * Check if a given object implements the CreateClusterSchema interface.
 */
export function instanceOfCreateClusterSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "workers" in value;
    isInstance = isInstance && "workerInstanceTypes" in value;
    isInstance = isInstance && "schedulerInstanceTypes" in value;

    return isInstance;
}

export function CreateClusterSchemaFromJSON(json: any): CreateClusterSchema {
    return CreateClusterSchemaFromJSONTyped(json, false);
}

export function CreateClusterSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClusterSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'softwareEnvironment': !exists(json, 'software_environment') ? undefined : json['software_environment'],
        'environ': !exists(json, 'environ') ? undefined : json['environ'],
        'privateToCreator': !exists(json, 'private_to_creator') ? undefined : json['private_to_creator'],
        'clusterTimeoutSeconds': !exists(json, 'cluster_timeout_seconds') ? undefined : json['cluster_timeout_seconds'],
        'options': !exists(json, 'options') ? undefined : SupersetRuntimeOptionsAPISchemaFromJSON(json['options']),
        'workers': json['workers'],
        'workerClass': !exists(json, 'worker_class') ? undefined : json['worker_class'],
        'workerOptions': !exists(json, 'worker_options') ? undefined : json['worker_options'],
        'workerInstanceTypes': json['worker_instance_types'],
        'workerDiskSize': !exists(json, 'worker_disk_size') ? undefined : json['worker_disk_size'],
        'workerDiskThroughput': !exists(json, 'worker_disk_throughput') ? undefined : json['worker_disk_throughput'],
        'workerDiskConfig': !exists(json, 'worker_disk_config') ? undefined : json['worker_disk_config'],
        'schedulerClass': !exists(json, 'scheduler_class') ? undefined : json['scheduler_class'],
        'schedulerOptions': !exists(json, 'scheduler_options') ? undefined : json['scheduler_options'],
        'schedulerInstanceTypes': json['scheduler_instance_types'],
        'schedulerDiskSize': !exists(json, 'scheduler_disk_size') ? undefined : json['scheduler_disk_size'],
        'schedulerDiskConfig': !exists(json, 'scheduler_disk_config') ? undefined : json['scheduler_disk_config'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
        'daskConfig': !exists(json, 'dask_config') ? undefined : json['dask_config'],
        'extraWorkerOnScheduler': !exists(json, 'extra_worker_on_scheduler') ? undefined : json['extra_worker_on_scheduler'],
        'nWorkerSpecsPerHost': !exists(json, 'n_worker_specs_per_host') ? undefined : json['n_worker_specs_per_host'],
        'envId': !exists(json, 'env_id') ? undefined : json['env_id'],
        'envName': !exists(json, 'env_name') ? undefined : json['env_name'],
        'coiledCloudEnvImage': !exists(json, 'coiled_cloud_env_image') ? undefined : json['coiled_cloud_env_image'],
        'autoSpec': !exists(json, 'auto_spec') ? undefined : json['auto_spec'],
        'useAwsCredsEndpoint': !exists(json, 'use_aws_creds_endpoint') ? undefined : json['use_aws_creds_endpoint'],
        'customSubdomain': !exists(json, 'custom_subdomain') ? undefined : json['custom_subdomain'],
        'batchJobIds': !exists(json, 'batch_job_ids') ? undefined : json['batch_job_ids'],
        'extraUserContainer': !exists(json, 'extra_user_container') ? undefined : json['extra_user_container'],
        'extraUserContainerIgnoreEntrypoint': !exists(json, 'extra_user_container_ignore_entrypoint') ? undefined : json['extra_user_container_ignore_entrypoint'],
        'schedulerSidecars': !exists(json, 'scheduler_sidecars') ? undefined : ((json['scheduler_sidecars'] as Array<any>).map(SidecarSchemaFromJSON)),
        'workerSidecars': !exists(json, 'worker_sidecars') ? undefined : ((json['worker_sidecars'] as Array<any>).map(SidecarSchemaFromJSON)),
        'hostSetupScript': !exists(json, 'host_setup_script') ? undefined : json['host_setup_script'],
        'userFileRefs': !exists(json, 'user_file_refs') ? undefined : ((json['user_file_refs'] as Array<any>).map(FileRefInputSchemaFromJSON)),
        'filestoresToAttach': !exists(json, 'filestores_to_attach') ? undefined : ((json['filestores_to_attach'] as Array<any>).map(FilestoreAttachmentRequestFromJSON)),
        'pauseOnExit': !exists(json, 'pause_on_exit') ? undefined : json['pause_on_exit'],
        'skipSsdMount': !exists(json, 'skip_ssd_mount') ? undefined : json['skip_ssd_mount'],
        'localVersions': !exists(json, 'local_versions') ? undefined : json['local_versions'],
    };
}

export function CreateClusterSchemaToJSON(value?: CreateClusterSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'software_environment': value.softwareEnvironment,
        'environ': value.environ,
        'private_to_creator': value.privateToCreator,
        'cluster_timeout_seconds': value.clusterTimeoutSeconds,
        'options': SupersetRuntimeOptionsAPISchemaToJSON(value.options),
        'workers': value.workers,
        'worker_class': value.workerClass,
        'worker_options': value.workerOptions,
        'worker_instance_types': value.workerInstanceTypes,
        'worker_disk_size': value.workerDiskSize,
        'worker_disk_throughput': value.workerDiskThroughput,
        'worker_disk_config': value.workerDiskConfig,
        'scheduler_class': value.schedulerClass,
        'scheduler_options': value.schedulerOptions,
        'scheduler_instance_types': value.schedulerInstanceTypes,
        'scheduler_disk_size': value.schedulerDiskSize,
        'scheduler_disk_config': value.schedulerDiskConfig,
        'tags': value.tags,
        'dask_config': value.daskConfig,
        'extra_worker_on_scheduler': value.extraWorkerOnScheduler,
        'n_worker_specs_per_host': value.nWorkerSpecsPerHost,
        'env_id': value.envId,
        'env_name': value.envName,
        'coiled_cloud_env_image': value.coiledCloudEnvImage,
        'auto_spec': value.autoSpec,
        'use_aws_creds_endpoint': value.useAwsCredsEndpoint,
        'custom_subdomain': value.customSubdomain,
        'batch_job_ids': value.batchJobIds,
        'extra_user_container': value.extraUserContainer,
        'extra_user_container_ignore_entrypoint': value.extraUserContainerIgnoreEntrypoint,
        'scheduler_sidecars': value.schedulerSidecars === undefined ? undefined : ((value.schedulerSidecars as Array<any>).map(SidecarSchemaToJSON)),
        'worker_sidecars': value.workerSidecars === undefined ? undefined : ((value.workerSidecars as Array<any>).map(SidecarSchemaToJSON)),
        'host_setup_script': value.hostSetupScript,
        'user_file_refs': value.userFileRefs === undefined ? undefined : ((value.userFileRefs as Array<any>).map(FileRefInputSchemaToJSON)),
        'filestores_to_attach': value.filestoresToAttach === undefined ? undefined : ((value.filestoresToAttach as Array<any>).map(FilestoreAttachmentRequestToJSON)),
        'pause_on_exit': value.pauseOnExit,
        'skip_ssd_mount': value.skipSsdMount,
        'local_versions': value.localVersions,
    };
}

